<template>
  <a-card
    :tab-list="tabs"
    :active-tab-key="searchForm.data.status"
    @tabChange="key => onTabChange(key)"
  >
    <div>
      <div>
        <a-form-model
          label-position="top"
          layout="vertical"
          :model="searchForm.data">
          <a-row :gutter="15">
            <a-col :span="3">
              <a-form-model-item :label="$t('BUY_AT')">
                <a-range-picker
                  style="width: 100%"
                  :show-time="{ format: 'HH:mm:ss' }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['Start Time', 'End Time']"
                  v-model="searchForm.data.timeScope"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="3">
              <a-form-model-item :label=" $t('ORDER_NO')">
                <a-input v-model="searchForm.data.orderNo" allowClear/>
              </a-form-model-item>
            </a-col>
            <a-col :span="3">
              <a-form-model-item :label="$t('telephone')">
                <a-input v-model="searchForm.data.telephone" allowClear/>
              </a-form-model-item>
            </a-col>
<!--            <a-col :span="2">-->
<!--              <a-form-model-item :label="$t('出生年月START')">-->
<!--                <a-month-picker placeholder="Select" v-model="searchForm.data.ageTimeScopeStart"/>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
<!--            <a-col :span="2">-->
<!--              <a-form-model-item :label="$t('出生年月END')">-->
<!--                <a-month-picker placeholder="Select" v-model="searchForm.data.ageTimeScopeEnd"/>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
            <a-col :span="2">
              <a-form-model-item :label="$t('地区')">
                <a-input v-model="searchForm.data.area" allowClear/>
              </a-form-model-item>
            </a-col>
<!--            <a-col :span="2">-->
<!--              <a-form-model-item :label="$t('金额范围')">-->
<!--                <a-input-number :min="0" v-model="searchForm.data.amountStart" type="number" allowClear/>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
<!--            <a-col :span="2">-->
<!--              <a-form-model-item :label="$t('金额end')">-->
<!--                <a-input-number :min="0" v-model="searchForm.data.amountEnd" type="number" allowClear controls:false/>-->
<!--              </a-form-model-item>-->
<!--            </a-col>-->
            <a-col :span="4">
              <a-form-model-item :label="$t('OPERATION')">
                <a-space>
                  <a-button
                    type="primary"
                    plain
                    icon="search"
                    @click="getOrderList">{{ $t('SEARCH') || '查询' }}
                  </a-button>
<!--                  <a-button-->
<!--                    type="primary"-->
<!--                    plain-->
<!--                    icon="export"-->
<!--                    @click="exportExcel">{{ $t('EXPORT') || '' }}-->
<!--                  </a-button>-->
                </a-space>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <a-spin :spinning="table.loading">
        <order-card
          :shipped-order="shippedOrder"
          :view-order-records="viewOrderRecords"
          :edit-order-express="editOrderExpress"
          :edit-order-status="editOrderStatus"
          :refund-order="refundOrder"
          :completed-order="completedOrder"
          :sync-w-d-t="syncWDT"
          :editable="true"
          :order="order"
          :key="order.id"
          v-for="order in table.data"/>
        <a-empty v-if="table.data.length===0"/>
      </a-spin>
      <a-pagination
        v-model="table.query.page"
        :total="table.query.total"
        show-size-changer
        :page-size="table.query.size"
        :pageSizeOptions="['5','20','50','100']"
        @showSizeChange="handleSizeChange"
        @change="handleSizeChange"
      >
        <template slot="buildOptionText" slot-scope="props">
          <span>{{ props.value }}条/页</span>
        </template>
      </a-pagination>
    </div>
    <a-modal
      title="发货信息"
      append-to-body
      :footer="null"
      width="50%"
      v-model="orderExpressForm.visible">
      <order-express-list
        v-if="orderExpressForm.visible"
        :order-id="orderExpressForm.data.id"/>
    </a-modal>
    <a-modal
      :footer="null"
      title="订单记录"
      append-to-body
      fo
      v-model="orderRecordForm.visible">
      <order-record-list
        v-if="orderRecordForm.visible"
        :order-id="orderRecordForm.data.id"/>
    </a-modal>
    <a-modal
      :footer="null"
      title="提示"
      v-model="form.visible">
      <order-edit
        v-if="form.visible"
        :order-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </order-edit>
    </a-modal>
    <a-modal
      :footer="null"
      title="修改订单状态"
      v-model="orderStatusForm.visible">
      <order-status-edit
        v-if="orderStatusForm.visible"
        :order-id="orderStatusForm.data.id"
        :on-cancel-handler="closeOrderStatusForm"
        :on-submit-handler="closeOrderStatusForm">
      </order-status-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryOrders,
  _deleteOrder,
  _completedOrder,
  _refundOrder,
  _syncWDT,
  _shippedOrder,
} from '@/api/orderApi';
import moment from 'moment';
import OrderCard from '@/components/OrderCard.vue';
// import DictSelect from '@/components/DictSelect.vue';
import OrderEdit from './OrderEdit.vue';
import OrderExpressList from '../orderExpress/OrderExpressList.vue';
import OrderRecordList from './OrderRecordList.vue';
import OrderStatusEdit from './OrderStatusEdit.vue';

function exportExcel() {
  const status = this.searchForm.data.status === 'ALL' ? '' : this.searchForm.data.status;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  window.open(`${process.env.VUE_APP_BASE_URL}/orders-export?status=${status}&sort=${this.table.sort.prop}&id=${this.searchForm.data.id}&telephone=${this.searchForm.data.telephone}&orderNo=${this.searchForm.data.orderNo}`);
}

async function getOrderList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const timeScope = this.searchForm.data.timeScope && this.searchForm.data.timeScope.length === 2
    ? this.searchForm.data.timeScope : [null, null];
  const result = await _queryOrders({
    startAt: timeScope[0] ? moment(timeScope[0])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    endAt: timeScope[1] ? moment(timeScope[1])
      .format('YYYY-MM-DD HH:mm:ss') : null,
    amountStart: this.searchForm.data.amountStart,
    amountEnd: this.searchForm.data.amountEnd,
    area: this.searchForm.data.area,
    ageStart: this.searchForm.data.ageTimeScopeStart,
    ageEnd: this.searchForm.data.ageTimeScopeEnd,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    telephone: this.searchForm.data.telephone,
    id: this.searchForm.data.id,
    orderNo: this.searchForm.data.orderNo,
    status: this.searchForm.data.status === 'ALL' ? null : this.searchForm.data.status,
    isWDTSync: this.searchForm.data.isWDTSync,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
  this.table.loading = false;
}

function addOrder() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editOrder(orderId) {
  this.form.data.id = orderId;
  this.form.visible = true;
}

function editOrderExpress(orderId) {
  this.orderExpressForm.data.id = orderId;
  this.orderExpressForm.visible = true;
}

function editOrderStatus(orderId) {
  this.orderStatusForm.data.id = orderId;
  this.orderStatusForm.visible = true;
}

function viewOrderRecords(orderId) {
  this.orderRecordForm.data.id = orderId;
  this.orderRecordForm.visible = true;
  this.$router.push(`/order/${orderId}/detail`);
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getOrderList();
}

function closeOrderStatusForm() {
  this.orderStatusForm.data.id = null
  this.orderStatusForm.visible = false;
  this.getOrderList();
}

function onTabChange(key) {
  this.searchForm.data.status = key;
  this.table.query.page = 1;
  this.getOrderList();
}

function verifyAmountSearch() {
  if (this.searchForm.amountEnd < this.searchForm.amountStart) {
    this.$message.warning('起始数不能大于结束数');
    return false;
  } else {
    return true;
  }
}

async function deleteOrder(orderId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteOrder(orderId);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.getOrderList();
    },
  });
}

async function syncWDT(orderId) {
  this.$confirm({
    title: '当前操作将使订单状态同步至旺店通，请确认？',
    content: '',
    onOk: async () => {
      const result = await _syncWDT(orderId);
      if (result) {
        this.$message.success('同步成功');
        this.getOrderList();
      }
    },
  });
}

async function refundOrder(orderId) {
  this.$confirm({
    title: '当前操作将使订单状态设为退款，请确认？',
    content: '',
    onOk: async () => {
      await _refundOrder(orderId);
      this.$message.success('申请退款成功');
      this.getOrderList();
    },
  });
}

async function completedOrder(orderId) {
  this.$confirm({
    title: '订单是否已经完成？',
    content: '',
    onOk: async () => {
      await _completedOrder(orderId);
      this.$message.success(this.$t('UPDATE_SUCCESS'));

      this.getOrderList();
    },
  });
}

async function shippedOrder(orderId) {
  this.$confirm({
    title: '是否发货？',
    content: '',
    onOk: async () => {
      await _shippedOrder(orderId);
      this.$message.success(this.$t('UPDATE_SUCCESS'));
      this.getOrderList();
    },
  });
}

function handleSizeChange(current, pageSize) {
  this.table.query.page = current;
  this.table.query.size = pageSize;
  this.getOrderList();
}

function handlePageChange(val) {
  this.table.query.page = val;
  this.getOrderList();
}

export default {
  name: 'OrderList',
  components: {
    // DictSelect,
    OrderRecordList,
    OrderExpressList,
    OrderCard,
    OrderEdit,
    OrderStatusEdit,
  },
  data() {
    return {
      tabs: [
        {
          key: 'ALL',
          tab: this.$t('ALL_ORDER'),
        }, {
          key: 'UN_PAID',
          tab: this.$t('UN_PAID'),
        }, {
          key: 'UN_SHIPPED',
          tab: this.$t('UN_SHIPPED'),
        }, {
          key: 'TO_BE_SHIPPED',
          tab: this.$t('TO_BE_SHIPPED'),
        }, {
          key: 'TRANSACTION_COMPLETED',
          tab: this.$t('TRANSACTION_COMPLETED'),
        },
        // {
        //   key: 'APPLY_REFUND',
        //   tab: this.$t('APPLY_REFUND'),
        // },
        // {
        //   key: 'REFUND_COMPLETED',
        //   tab: this.$t('REFUND_COMPLETED'),
        // },
        {
          key: 'CANCEL',
          tab: this.$t('CANCEL'),
        },
      ],
      // location: {
      //   data: ['北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区', '台湾省', '香港特别行政区', '澳门特别行政区'],
      // },
      searchForm: {
        data: {
          id: '',
          orderNo: '',
          status: 'ALL',
          timeScope: [],
          ageTimeScopeStart: '',
          ageTimeScopeEnd: '',
          area: '',
          amountStart: '',
          amountEnd: '',
          telephone: '',
          isWDTSync: '',
        },
      },
      orderExpressForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      orderRecordForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      orderStatusForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        loading: false,
        data: [],
        query: {
          page: 1,
          size: 5,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getOrderList,
    deleteOrder,
    editOrder,
    editOrderExpress,
    editOrderStatus,
    addOrder,
    closeForm,
    shippedOrder,
    viewOrderRecords,
    completedOrder,
    handleSizeChange,
    handlePageChange,
    refundOrder,
    onTabChange,
    exportExcel,
    syncWDT,
    closeOrderStatusForm,
    verifyAmountSearch,
  },
  created() {
    this.getOrderList();
  },
  activated() {
    if (!this.$route.meta.isUseCache) {
      this.getOrderList();
    }
  }
};
</script>

<style scoped>

</style>
